window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
/**
 * Generic layer for making JSONP requests
 * Accepts the following parameters on the requestObject:
 * url - request URL, should be the full URL as needed by the server
 * encoding - if encoding is needed (default is UTF 8)
 * success - method to get called back will always receive the data from the request
 * error - a method to call on error
 * callback - the parameter name expected in the URL by the replying service
 * callbackName -  the name of the function to CREATE. This is for REQUEST CACHING PURPOSES ONLY. IF YOU SUPPLY A REAL FUNCTION IT WILL BE OVERRIDDEN
 * retries - if there is no valid response, default is 2
 * timeout - default 10 seconds, can be set in seconds
 * context - the context we want the succes/error callbacks to run in, if not supplied will be null
 */
lpTag.taglets.jsonp = lpTag.taglets.jsonp || (function (window) {//Pass in the window so it's a local variable in the scope

    var defaults = { //Can be configured with configure public method
            callback: 'cb', //default callback parameter on the URL
            encoding: 'UTF-8',//default encoding for all our requests
            timeout: 10000,//default timeout for unanswered requests
            retries: 2,//default retry for unanswered requests
            metricsCount: 100, //default dump interval of info to lpAjax about request timing
            metricsTimeout : 60000 //Default time to send metrics even if count isn't reached
        },
        logTypes = { ERROR: "ERROR", DEBUG: "DEBUG", INFO: "INFO" },
        initialised = true,
        mURLlen = 2083,//The maximum URL length
        cbPrefix = 'lpCb',//default prefix for all our callbacks
        buffReq = {},//The request buffer for new requests
        callCount = 0,//The total number of calls we've made
        buffReqCount = 0,//The amount of requests in the buffer
        pendReqCount = 0,//The pending requests already made
        refusedCount = 0,//The number of requests refused due to none matching requirements
        errCount = 0,//The error count
        requestStats = [],//The statistical information we have per domain
        errTOid,//The error checking timeout id
        metricsTOId, // The metrics timeout id
        cb = {},//The callback list we have
        callbackSampleLength = _createCallbackName(true).length,
        version = "1.1.7",
        transportType = "jsonp";

    /************************ PUBLIC METHODS ***************************/

    function init() {
        if(lpTag && lpTag.taglets && lpTag.taglets.lpAjax) {
            try{
                lpTag.taglets.lpAjax.addTransport(transportType, publicAPI);
            }catch(exc){}
        }
        _setMetricsTimeout();
    }

    /**
     * Sets the default configuration we want to use for requests,
     * can be overridden on a request basis
     * properties: callback, encoding, timeout , retries
     * @param configurationObj
     */
    function configure(configurationObj) {
        if (configurationObj) {
            for (var key in configurationObj) {
                if (defaults.hasOwnProperty(key) && configurationObj.hasOwnProperty(key)) {
                    defaults[key] = configurationObj[key];
                }
            }
        }
        init();
    }

    /**
     * Checks if this transport can handle the request
     * @param reqObj
     * @return {Boolean}
     */
    function isValidRequest(reqObj) {
        var validRequest = false;
        if (initialised && reqObj && reqObj.url) {
            var callbackExists = false;
            if(reqObj.callbackName && typeof reqObj.callbackName === 'string'){
                if(cb[reqObj.callbackName] || window[reqObj.callbackName]){
                    callbackExists = true;
                }
            }
            var totalLength;
            try {
                totalLength = _calculateRequestLength(reqObj);
            } catch (e) {
                _log("Could not evaluate the length  of the request, e=" + e, logTypes.ERROR, "isValidRequest");
                validRequest = false;
            }
            if (typeof(totalLength) !== 'undefined' && (totalLength < mURLlen && !callbackExists)) {
                validRequest = true;
            }
        }
        return validRequest;
    }

    /**
     * Builds the call URL, Buffers the requests and runs requests
     * @param reqObj
     */
    function issueCall(reqObj) {
        var callUrl;
        if (isValidRequest(reqObj)) {
            reqObj = _setRequestDefaults(reqObj);
            if(!reqObj.callbackName || typeof reqObj.callbackName !== 'string'){//Allow to send in a callbackName
                reqObj.callbackName = cbPrefix + _createCallbackName();
            }else{
                reqObj.retries = 0;
            }
            callUrl = reqObj.url + (reqObj.url.indexOf('?') > -1 ? '&' : '?') + reqObj.callback + '=' + '' + reqObj.callbackName;
            if(reqObj.data) {
                callUrl += "&" + _convertDataToQueryParams(reqObj.data);
            }
            if(reqObj.query){
                callUrl += "&" + _convertDataToQueryParams(reqObj.query);
            }
            reqObj.callUrl = callUrl;
            if (_bufferRequest(reqObj)) {
                _addToCallBackList(reqObj);
                _sendRequests();
            } else {//Log error for URL overflow
                _log("URL request was too long and was not sent, url: " + callUrl, logTypes.ERROR, "issueCall");
            }
        } else {
            _log("URL request was too long or static callback name already exists, url: " + callUrl, logTypes.ERROR, "issueCall");
            _incrementRefusedCount();
            if (reqObj && reqObj.error) {
                _runCallBack(logTypes.ERROR, reqObj.error, _getErrorResponse(600, "Transport - JSONP - unable to run request: " + reqObj.url), reqObj.context);
            }
            return false;
        }
        return true;
    }

    /**
     * Gets the defaults for the transport
     * @returns {{}}
     */
    function getDefaults(){
        var tDefaults = {};
        for (var defKey in defaults) {
            if (defaults.hasOwnProperty(defKey)) {
                tDefaults[defKey] = defaults[defKey];
            }
        }
        return tDefaults;
    }

    /************************ PRIVATE METHODS ***************************/

    /**
     * Sets up the request with default values if they have not been passed in
     * @param reqObj
     */
    function _setRequestDefaults(reqObj) {
        if (typeof reqObj === 'string') {
            var url = reqObj;
            reqObj = { url: url };
        }
        if (!reqObj.url) {
            return false;
        } //nothing to send

        reqObj.encoding = reqObj.encoding || defaults.encoding;
        reqObj.callback = reqObj.callback || defaults.callback;
        reqObj.retries = typeof reqObj.retries === 'number' ? reqObj.retries : defaults.retries;
        reqObj.timeout = reqObj.timeout ? reqObj.timeout : defaults.timeout;

        return reqObj;
    }

    /**
     * Create a callback name that's random every time
     */
    function _createCallbackName(notRandom) {
        var maxValue = 99999, separator = "x", cbName;
        if (!notRandom) {
            cbName = Math.round(Math.random() * maxValue) + separator + Math.round(Math.random() * maxValue);
        } else {
            cbName = maxValue + separator + maxValue;
        }
        return cbName;
    }

    /**
     * Generic method to create error responses
     * @param code
     * @param errorMessage
     * @returns {{statusCode: *, responseCode: *, error: *, body: string}}
     */
    function _getErrorResponse(code, errorMessage){
        return { statusCode: code, responseCode: code, error: errorMessage , body: "ERROR" };
    }

    /**
     * Create a script id tag for the DOM
     */
    function _createScriptId() {
        return "scr" + Math.round(Math.random() * 999999999) + '_' + Math.round(Math.random() * 999999999);
    }

    /**
     * Calculates the URL Length in JSONP.
     * @param reqObj
     * @returns {*}
     * @private
     */
    function _calculateRequestLength(reqObj){
        var callbackNameLength = callbackSampleLength;

        if(reqObj.callbackName && typeof reqObj.callbackName === 'string'){
            callbackNameLength = reqObj.callbackName.length;
        }

        return  (4 + (reqObj.callback || defaults.callback).length +
                    reqObj.url.length +
                    callbackNameLength +
                    _convertDataToQueryParams(reqObj.data).length +
                    _convertDataToQueryParams(reqObj.query).length);
    }

    /**
     * Takes the data parameter and converts it to a query string
     * @param data
     * @return {String}
     */
    function _convertDataToQueryParams(data) {
        var queryString = "";
        if (typeof data === 'string') {
            queryString += data;
        } else {
            var first = true;
            for (var key in data) {
                var value;
                if (typeof data[key] == 'object') {
                    value = _stringify(data[key]);
                } else if (typeof data[key] !== 'function') {
                    value = data[key];
                }
                if (typeof value !== "undefined") {
                    if (!first) {
                        queryString += "&";
                    }
                    queryString += encodeURIComponent(key) + "=" + encodeURIComponent(value);
                    first = false;
                }
            }
        }
        return queryString;
    }

    /**
     * This function was added because of incompatibility between the JSON.stringify and Prototype.js library
     * When a costumer uses Prototype.js library, It overrides the Array.prototype.toJSON function the the native JSON
     * uses. This causes arrays to be double quoted and Shark to fail on those SDEs.
     * The function accepts a value and and uses the native JSON.stringify
     * Can throw an exception (same as JSON.stringify).
     */
    function _stringify(value) {
        var stringified;
        if (typeof Array.prototype.toJSON === 'function') {
            var toJSONPrototype = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
            try {
                stringified = JSON.stringify(value);
            } catch (e) {
                Array.prototype.toJSON = toJSONPrototype;
                throw e;
            }
            Array.prototype.toJSON = toJSONPrototype;
        } else {
            stringified = JSON.stringify(value);
        }
        return stringified;
    }

    /**
     * Buffers requests according to subDomain to insure we don't overflow the browser
     * @param reqObj
     */
    function _bufferRequest(reqObj) {
        var validRequest = false;
        var domainRegEx = new RegExp(/(http{1}s{0,1}?:\/\/)([^\/\?]+)(\/?)/ig);
        var matches;
        if (reqObj.callUrl.indexOf("http") === 0) {
            matches = domainRegEx.exec(reqObj.callUrl);
        } else {
            matches = domainRegEx.exec(window.location.href);
        }
        if (matches && matches.length >= 3 && matches[2] !== "") {
            var domain = matches[2].toLowerCase(); // 0 - full match 1- HTTPS 2- domain
            reqObj.domainMatch = domain;
            buffReq[domain] = buffReq[domain] || [];
            buffReq[domain].inFlight = buffReq[domain].inFlight || 0;
            buffReq[domain].push(reqObj);
            validRequest = true;
            buffReqCount = buffReqCount + 1;
            _log('buffered URL: ' + reqObj.callUrl, logTypes.DEBUG, 'lpTag.taglets.jsonp.bufferRequest');
        } else {
            _log('NO MATCH for URL: ' + reqObj.callUrl, logTypes.ERROR, 'lpTag.taglets.jsonp.bufferRequest');
        }
        return validRequest;
    }

    /**
     * Checks the buffer and sends requests according to available net slots
     */
    function _sendRequests() {
        var currentSubDomain;
        for (var subDomain in buffReq) {
            if (buffReq.hasOwnProperty(subDomain)) {
                currentSubDomain = buffReq[subDomain];
                var breakLoop = false;
                while (!breakLoop && currentSubDomain.inFlight < 6 && currentSubDomain.length > 0) {
                    var request = currentSubDomain.shift();
                    if (request) {
                        _log('Sent URL: ' + request.callUrl, logTypes.DEBUG, 'lpTag.taglets.jsonp.sendRequests');
                        request.scriptId = _makeScriptCall(request.callUrl, request.encoding, request.callbackName);
                        request.startTime =  new Date().getTime();
                        _incrementCallCounts(subDomain, request.callbackName, request.timeout);
                        buffReqCount = buffReqCount - 1;
                    } else {
                        breakLoop = true;
                    }
                }
            }
        }
        currentSubDomain = null;
    }

    /**
     * Checks for timed out requests that are pending and functions which were kept to prevent errors on the page
     */
    function _checkForErrors() {
        clearTimeout(errTOid);
        errTOid = null;
        var now = new Date();
        for (var key in cb) {//Check for requests taking too long
            if (cb.hasOwnProperty(key) && cb[key].launchTime) {
                var timeElapsed = now - cb[key].launchTime;
                if (cb[key].loadTime || timeElapsed > cb[key].timeout) {//Call error callBack
                    window[key].apply(null, [
                        _getErrorResponse(408, { message: "Request timed out", name: "timeout" }),
                        true
                    ]);//true here signals error will be called back
                }
            }
        }

        if (pendReqCount > 0) {
            errTOid = setTimeout(_checkForErrors, 1000);
        }
    }

    /**
     * Creates the script tag for the request and returns the scriptId on the page
     * @param URL
     * @param encoding
     */
    function _makeScriptCall(URL, encoding, callbackName) {
        var scriptId = _createScriptId();
        var scriptCall = document.createElement("script");
        scriptCall.setAttribute("type", "text/javascript");
        scriptCall.setAttribute("charset", encoding);
        //These binds are to listen to script load time to lower error notification time for failed scripts
        //Note this will only work for requests that end with .js
        scriptCall.onload = function () {//Try for all browsers, should never have negative impact
            if(cb[callbackName]){
                cb[callbackName].loadTime = new Date();
            }
            this.onload = this.onerror = this.onreadystatechange = null;
        };
        if(!window.addEventListener){//Mainly for IE, since IE8- do not supply onerror handlers
            scriptCall.onreadystatechange = function(){
                if (this.readyState) {
                    if(this.readyState === "loaded" || this.readyState === "complete"){
                        if(cb[callbackName]){
                            cb[callbackName].loadTime = new Date();
                        }
                        this.onload = this.onerror = this.onreadystatechange = null;
                    }
                }
            };
        }else{
            //All other browsers support this normalized behavior
            scriptCall.onerror = function(){
                if(cb[callbackName]){
                    cb[callbackName].loadTime = new Date();
                }
                this.onload = this.onerror = this.onreadystatechange = null;
            };
        }
        scriptCall.setAttribute("src", URL);
        scriptCall.setAttribute("id", scriptId);
        document.getElementsByTagName("head")[0].appendChild(scriptCall);
        if (!errTOid) {
            errTOid = setTimeout(_checkForErrors, 1000);
        }
        scriptCall = null;
        return scriptId;
    }

    /**
     * Increments the counters on the correct domain and general request counter
     * @param domainMatch
     * @param callbackName
     * @param timeout
     */
    function _incrementCallCounts(domainMatch, callbackName, timeout) {
        buffReq[domainMatch].inFlight = buffReq[domainMatch].inFlight + 1;
        cb[callbackName] = { launchTime: new Date(), timeout: timeout };
        pendReqCount = pendReqCount + 1;
        callCount = callCount + 1;
    }

    /**
     * Increments the counter of calls we can't make
     */
    function _incrementRefusedCount(){
        refusedCount = refusedCount + 1;
    }

    /**
     * Removes the script tag for the request
     * @param scriptId
     */
    function _removeScript(scriptId) {
        //Lesson learned from: http://neil.fraser.name/news/2009/07/27/
        var scriptTag = document.getElementById(scriptId);
        if (scriptTag) {
            try {
                scriptTag.parentNode.removeChild(scriptTag);
            } catch (exc) {
                _log("error when removing script", logTypes.ERROR, "removeScript");
            }
        }
    }

    /**
     * Decrements the call counters in this layer
     */
    function _decrementRequestCount(domainMatch) {
        buffReq[domainMatch].inFlight = buffReq[domainMatch].inFlight - 1;
        pendReqCount = pendReqCount - 1;
    }

    /**
     * Callback for all requests, runs cleanup and executes passed in methods
     * @param data
     * @param reqObj
     * @param isError
     * @private
     */
    function _defaultCallBack(data, reqObj, isError) {
        _addToStats(reqObj.startTime, reqObj.url, isError);
        _removeScript(reqObj.scriptId); //Clear the DOM of the script call
        _decrementRequestCount(reqObj.domainMatch);
        _removeFromCallbacksList(reqObj.callbackName, isError);
        if (isError) {//Decides if there is an error here
            if(reqObj.callbackName){
                reqObj.callbackName = null;
                delete reqObj.callbackName;
            }
            _errorCallback(data, reqObj);
        } else {
            _cleanupCallParameters(reqObj);
            _runCallBack("callback", reqObj.success, data, reqObj.context);
            reqObj = null;
            _sendRequests();
        }
    }

    /**
     * Publishes stats to lpAjax to decide if we want to report this
     */
    function _publishMetrics(){
        var res;
        if(lpTag.taglets.lpAjax &&
            lpTag.taglets.lpAjax.publishMetrics &&
            requestStats.length > 0){
            res = {
                tags: [ { transport: transportType } ],
                metrics : requestStats
            };
            lpTag.taglets.lpAjax.publishMetrics(res);
            requestStats.length = 0;
        }
        _setMetricsTimeout();
    }

    /**
     * Clears any previous timeout to set this data and sets up
     * the next time this should happen
     */
    function _setMetricsTimeout(){
        if(metricsTOId) {
            clearTimeout(metricsTOId);
        }
        metricsTOId = setTimeout(_publishMetrics, defaults.metricsTimeout);
    }

    /**
     * Adding the time spent on the request
     * @param startTime
     */
    function _addToStats(startTime, url, isError){
        var requestDuration, now;
        if(startTime) {
            now = new Date().getTime();
            requestDuration = (now - startTime);
            requestStats.push({
                rd: requestDuration,
                ts: startTime,
                url :url,
                method: "GET",
                statusCode: isError ? 400 : 200
            });

            if(requestStats.length >= defaults.metricsCount) {
                _publishMetrics();
            }
        }
    }

    /**
     * Error callback for all requests, runs cleanup and executes passed in methods
     * @param reqObj
     */
    function _errorCallback(errorData, reqObj) {
        errCount = errCount + 1;
        if (reqObj.retries > 0) {//Set up another attempt at calling this URL
            reqObj.retries = reqObj.retries - 1;
            issueCall(reqObj);
        } else {//Notify of failure
            _cleanupCallParameters(reqObj);
            _runCallBack(logTypes.ERROR, reqObj.error, errorData || _getErrorResponse(408, { id: 408, name: "TIMEOUT", message: "Request has timed out on all retries" }), reqObj.context);
            reqObj = null;
            _sendRequests();
        }
    }

    /**
     * Cleans up parameters from the request object
     * @param reqObj
     */
    function _cleanupCallParameters(reqObj) {
        var addedParams = ["callUrl", "retries", "id", "requestTimeout", "type", "encoding", "launchTime", "callbackName", "domainMatch", "startTime"];
        for (var i = 0; i < addedParams.length; i++) {
            if (reqObj.hasOwnProperty(addedParams[i])) {
                reqObj[addedParams[i]] = null;
                delete reqObj[addedParams[i]];
            }
        }
    }

    /**
     * Runs the callback passed protected
     * @param type - the function type for logging purposes
     * @param callback - the function that needs to run
     * @param data - the data passed on to that function
     * @param context - the context if any ti run this in
     */
    function _runCallBack(type, callback, data, context) {
        if (typeof callback === 'function') {
            try {
                callback.call(context || null, data);
                callback = null;
            } catch (e) {
                _log("Exception in execution of callback, type :" + type + " e=[" + e.message + "]", logTypes.ERROR, "runCallback");
            }
        } else {
            _log("No callback, of type :" + type, logTypes.INFO, "runCallback");
        }
    }

    /**
     * Removes callback from the list, in case of error we set the function with a new function to prevent errors on page
     * @param callbackName - the callback to remove from the queue
     * @param error - if this is because of an error (to set up a protection function on page)
     */
    function _removeFromCallbacksList(callbackName, error) {
        cb[callbackName] = null;
        delete cb[callbackName];
        if (error === true) {
            window[callbackName] = function () {//Function to clear itself - prevents errors being thrown on page
                window[callbackName] = null;
                try {
                    delete window[callbackName];
                } catch (err) {}
            };
        } else {
            window[callbackName] = null;
            try {
                delete window[callbackName];
            } catch (err) {
            }
        }
    }

    /**
     * Creates a closure scope to keep the object reference to the defaukt function
     * @param reqObj
     */
    function _addToCallBackList(reqObj) {
        if(cb[reqObj.callbackName]){
            _incrementRefusedCount();
            _errorCallback(_getErrorResponse(409, { message: "This callbackName is already in a pending request and can't be serviced", id: 409, name: "CONFLICT" }), reqObj);
        }else{
            window[reqObj.callbackName] = function (data, error) {
                _defaultCallBack(data, reqObj, error);
            };
        }
    }

    /**
     * Passes a log to lpTag
     * @param msg
     * @param type
     * @param callingObj
     */
    function _log(msg, type, callingObj) {
        if (window.lpTag && lpTag.log) {
            if(typeof msg === 'string' && callingObj){
                msg = callingObj + ': ' + msg;
            }
            lpTag.log(msg, type, transportType);
        }
    }


    var publicAPI =  {//These are the exposed public methods of this SINGLETON
        init: init,
        configure: configure,
        issueCall: issueCall,
        isValidRequest: isValidRequest,
        getVersion: function () { return version; },
        getName: function () { return transportType; },
        getDefaults: getDefaults,
        inspect: function () {
            return {
                name: transportType,
                version: version,
                callsMade: callCount,
                errorsFound: errCount,
                pending: pendReqCount,
                buffered: buffReqCount,
                refused: refusedCount ,
                defaults: getDefaults()
            };
        }
    };

    /************************ Execution ***************************/
    init();

    return publicAPI;
})(window);


/*** EXPORTS FROM exports-loader ***/
module.exports = lpTag.taglets.jsonp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lp-transporter/src/transports/jsonp.js
// module id = 414
// module chunks = 0